import { render } from "./document-text.vue?vue&type=template&id=4e00ed96"
const script = {}

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__